(function () {
  "use strict";

  /* ═══ CONFIG ═══ */
  var WEBHOOK_URL =
    "https://hook.us2.make.com/lrgeifki4ked82755afwlade5nybfefi";
  var SUBMIT_TIMEOUT_MS = 15000;
  var COOLDOWN_MS = 60000;

  /* ═══ DEADLINE DISPLAY TEXT (matches Make S1 Text Parser) ═══ */
  var DEADLINE_LABELS = {
    rush: "Rush Delivery (Within 1 month)",
    standard: "Standard Delivery (Within 3 months)",
    flexible: "Flexible Delivery (Within 6 months)",
    event: "For a specific event (please specify below)",
    no_event_yet: "No event yet / still planning",
  };

  /* ═══ DOM REFS ═══ */
  var form, submitBtn, successEl, errorBanner;
  var deadlineSelect, eventField;

  /* ═══ INIT ═══ */
  document.addEventListener("DOMContentLoaded", function () {
    form = document.getElementById("quoteForm");
    submitBtn = document.getElementById("qfSubmitBtn");
    successEl = document.getElementById("qfSuccess");
    errorBanner = document.getElementById("qfErrorBanner");
    deadlineSelect = document.getElementById("qfDeadline");
    eventField = document.getElementById("qfEventField");

    if (!form) return;

    setupConditionalFields();
    setupCharCount();
    setupEmailConfirmCheck();
    form.addEventListener("submit", handleSubmit);
  });

  /* ═══ CONDITIONAL FIELDS ═══ */
  function setupConditionalFields() {
    if (!deadlineSelect || !eventField) return;
    deadlineSelect.addEventListener("change", function () {
      if (deadlineSelect.value === "event") {
        eventField.classList.remove("qf-hidden");
      } else {
        eventField.classList.add("qf-hidden");
        var eventInput = document.getElementById("qfEventName");
        if (eventInput) eventInput.value = "";
      }
    });
  }

  /* ═══ CHAR COUNT ═══ */
  function setupCharCount() {
    var textarea = form ? form.querySelector('textarea[name="message"]') : null;
    var counter = document.getElementById("qfMsgCount");
    if (!textarea || !counter) return;
    textarea.addEventListener("input", function () {
      counter.textContent = textarea.value.length;
    });
  }

  /* ═══ CONFIRM EMAIL — LIVE CHECK ═══ */
  function setupEmailConfirmCheck() {
    var email = form ? form.querySelector('input[name="email"]') : null;
    var emailConfirm = document.getElementById("qfEmailConfirm");
    if (!email || !emailConfirm) return;

    function check() {
      /* clear only this field's previous error */
      var prevErr = emailConfirm.parentNode.querySelector(".qf-field-error");
      if (prevErr) prevErr.parentNode.removeChild(prevErr);
      emailConfirm.classList.remove("qf-error");
      /* don't nag while the confirm field is still empty */
      if (emailConfirm.value.trim() === "") return;
      if (
        email.value.trim().toLowerCase() !==
        emailConfirm.value.trim().toLowerCase()
      ) {
        showFieldError(
          emailConfirm,
          "Email addresses don't match — please re-enter to confirm."
        );
      }
    }

    /* validate when leaving the confirm field */
    emailConfirm.addEventListener("blur", check);
    /* once an error is shown, update live so it clears the moment it matches */
    emailConfirm.addEventListener("input", function () {
      if (emailConfirm.classList.contains("qf-error")) check();
    });
    /* re-check if the user edits the primary email afterwards */
    email.addEventListener("blur", function () {
      if (emailConfirm.value.trim() !== "") check();
    });
  }

  /* ═══ VALIDATION ═══ */
  function clearErrors() {
    var errorEls = form.querySelectorAll(".qf-field-error");
    for (var i = 0; i < errorEls.length; i++) {
      errorEls[i].parentNode.removeChild(errorEls[i]);
    }
    var errorInputs = form.querySelectorAll(".qf-error");
    for (var j = 0; j < errorInputs.length; j++) {
      errorInputs[j].classList.remove("qf-error");
    }
    if (errorBanner) errorBanner.classList.add("qf-hidden");
  }

  function showFieldError(input, message) {
    input.classList.add("qf-error");
    var p = document.createElement("p");
    p.className = "qf-field-error";
    p.textContent = message;
    input.parentNode.appendChild(p);
  }

  function validateForm() {
    clearErrors();
    var firstError = null;

    /* Name */
    var name = form.querySelector('input[name="name"]');
    if (!name.value.trim() || name.value.trim().length < 2) {
      showFieldError(name, "Please enter your name.");
      if (!firstError) firstError = name;
    }

    /* Email */
    var email = form.querySelector('input[name="email"]');
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.value.trim() || !emailRegex.test(email.value.trim())) {
      showFieldError(email, "Please enter a valid email address.");
      if (!firstError) firstError = email;
    }

    /* Confirm Email — typo guard (id only, value not sent to backend) */
    var emailConfirm = document.getElementById("qfEmailConfirm");
    if (emailConfirm &&
        email.value.trim().toLowerCase() !== emailConfirm.value.trim().toLowerCase()) {
      showFieldError(emailConfirm, "Email addresses don't match — please re-enter to confirm.");
      if (!firstError) firstError = emailConfirm;
    }

    /* Country */
    var country = form.querySelector('input[name="country"]');
    if (!country.value.trim()) {
      showFieldError(country, "Please enter your country.");
      if (!firstError) firstError = country;
    }

    /* Character Name */
    var charName = form.querySelector('input[name="character_name"]');
    if (!charName.value.trim()) {
      showFieldError(charName, "Please enter the character name.");
      if (!firstError) firstError = charName;
    }

    /* Series Name */
    var series = form.querySelector('input[name="series_name"]');
    if (!series.value.trim()) {
      showFieldError(series, "Please enter the series or game name.");
      if (!firstError) firstError = series;
    }

    /* Deadline */
    if (!deadlineSelect.value) {
      showFieldError(deadlineSelect, "Please select your timeline.");
      if (!firstError) firstError = deadlineSelect;
    }

    return { valid: !firstError, firstError: firstError };
  }

  /* ═══ DEADLINE → kintone 内部値マッピング ═══ */
  var DEADLINE_KINTONE = {
    standard: "standard",
    rush: "rush",
    flexible: "flexible",
    event: "event",
    // No event yet is accepted at the intake edge and stored as flexible internally.
    no_event_yet: "flexible",
  };

  /* ═══ PAYLOAD ═══ */
  function buildPayload() {
    var deadlineDisplay = "";
    var deadlineInternal = "";
    if (deadlineSelect.value) {
      deadlineDisplay =
        DEADLINE_LABELS[deadlineSelect.value] || deadlineSelect.value;
      deadlineInternal =
        DEADLINE_KINTONE[deadlineSelect.value] || deadlineSelect.value;
    }

    var eventName = document.getElementById("qfEventName");
    var referralCodeEl = form.querySelector('[name="referral_code"]');
    var referralFirstCodeEl = form.querySelector('[name="referral_first_code"]');
    var referralLandingUrlEl = form.querySelector('[name="referral_landing_url"]');
    var referralCapturedAtEl = form.querySelector('[name="referral_captured_at"]');
    var twcReferral = window.TWC_REFERRAL || {};

    /* case_id 自動生成: TWC-YYYYMMDD-HHmmss */
    var now = new Date();
    var pad = function (n) { return n < 10 ? "0" + n : String(n); };
    var caseId = "TWC-"
      + now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate())
      + "-" + pad(now.getHours()) + pad(now.getMinutes()) + pad(now.getSeconds());

    return {
      case_id: caseId,
      name: form.querySelector('input[name="name"]').value.trim(),
      email: form.querySelector('input[name="email"]').value.trim(),
      country: form.querySelector('input[name="country"]').value.trim(),
      character_name: form
        .querySelector('input[name="character_name"]')
        .value.trim(),
      series_name: form
        .querySelector('input[name="series_name"]')
        .value.trim(),
      deadline: deadlineDisplay,
      deadline_value: deadlineInternal,
      event_name: eventName ? eventName.value.trim() : "",
      message: (
        form.querySelector('textarea[name="message"]').value || ""
      ).trim(),
      marketing_consent: document.getElementById("qfConsent")
        ? document.getElementById("qfConsent").checked
        : false,
      referral_code: referralCodeEl
        ? referralCodeEl.value.trim()
        : twcReferral.code || "",
      referral_first_code: referralFirstCodeEl
        ? referralFirstCodeEl.value.trim()
        : twcReferral.firstCode || "",
      referral_landing_url: referralLandingUrlEl
        ? referralLandingUrlEl.value.trim()
        : twcReferral.landingUrl || "",
      referral_captured_at: referralCapturedAtEl
        ? referralCapturedAtEl.value.trim()
        : twcReferral.capturedAt || "",
      submitted_at: new Date().toISOString(),
    };
  }

  /* ═══ SUBMIT ═══ */
  function handleSubmit(e) {
    e.preventDefault();

    /* Honeypot check */
    var honeypot = document.getElementById("qfWebsite");
    if (honeypot && honeypot.value !== "") {
      showSuccess();
      return;
    }

    /* Cooldown check */
    var lastSubmit = 0;
    try {
      lastSubmit = parseInt(
        localStorage.getItem("twc_fc_last_submit") || "0",
        10
      );
    } catch (e) { /* storage unavailable */ }
    if (Date.now() - lastSubmit < COOLDOWN_MS) {
      showBannerError("Please wait a moment before submitting again.");
      return;
    }

    /* Validate */
    var result = validateForm();
    if (!result.valid) {
      if (result.firstError && result.firstError.scrollIntoView) {
        result.firstError.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    /* Build & Send */
    setSubmitState("submitting");
    var payload = buildPayload();

    var controller =
      typeof AbortController !== "undefined"
        ? new AbortController()
        : null;
    var timeoutId = null;
    if (controller) {
      timeoutId = setTimeout(function () {
        controller.abort();
      }, SUBMIT_TIMEOUT_MS);
    }

    var fetchOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };
    if (controller) {
      fetchOptions.signal = controller.signal;
    }

    fetch(WEBHOOK_URL, fetchOptions)
      .then(function (response) {
        if (timeoutId) clearTimeout(timeoutId);
        if (response.ok) {
          try {
            localStorage.setItem(
              "twc_fc_last_submit",
              String(Date.now())
            );
          } catch (e) { /* storage unavailable */ }
          showSuccess();
        } else {
          setSubmitState("default");
          showBannerError(
            "Something went wrong. Please try again in a few moments."
          );
        }
      })
      .catch(function (err) {
        if (timeoutId) clearTimeout(timeoutId);
        setSubmitState("default");
        if (err && err.name === "AbortError") {
          showBannerError(
            "The request timed out. Please try again."
          );
        } else if (!navigator.onLine) {
          showBannerError(
            "You appear to be offline. Please check your connection and try again."
          );
        } else {
          showBannerError(
            "We couldn\u2019t process your request. Please try again or contact us at cs@tokyo-wig-create.com."
          );
        }
      });
  }

  /* ═══ UI STATE ═══ */
  function setSubmitState(state) {
    if (!submitBtn) return;
    if (state === "submitting") {
      submitBtn.disabled = true;
      submitBtn.innerHTML =
        '<span class="qf-spinner"></span>Submitting\u2026';
    } else {
      submitBtn.disabled = false;
      submitBtn.innerHTML = "Submit Your Quote Request \u2192";
    }
  }

  function showSuccess() {
    if (form) form.classList.add("qf-hidden");
    if (successEl) successEl.classList.remove("qf-hidden");
    if (successEl && successEl.scrollIntoView) {
      successEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    // Meta Pixel — Lead event
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Lead', {
        content_name: 'Quote Request',
        content_category: 'Custom Wig'
      });
    }

    // Google Analytics 4 — generate_lead event
    if (typeof gtag !== 'undefined') {
      gtag('event', 'generate_lead', {
        event_category: 'Quote',
        event_label: 'Custom Wig Quote Request'
      });
    }
  }

  function showBannerError(message) {
    if (!errorBanner) return;
    errorBanner.textContent = message;
    errorBanner.classList.remove("qf-hidden");
    errorBanner.scrollIntoView({ behavior: "smooth", block: "center" });
  }
})();
